import { CopyableValue } from '@/components/common/CopyableValue'

interface OrderExternalIdLabelProps {
  externalId: string
  /** Truncate the id with an ellipsis past this length; full value stays in the tooltip. */
  maxLength?: number
}

export function OrderExternalIdLabel({ externalId, maxLength = 15 }: OrderExternalIdLabelProps) {
  const trimmed = externalId?.trim() ?? ''
  const isTruncated = trimmed.length > maxLength
  const display = isTruncated ? `${trimmed.slice(0, maxLength)}…` : trimmed

  // Only offer copy when a real id exists; otherwise render the plain label.
  if (!trimmed) {
    return <span className="text-xs font-medium leading-5 text-text-body dark:text-gray-400">Order #:</span>
  }

  return (
    <span className="text-xs font-medium leading-5 text-text-body dark:text-gray-400">
      Order #:{' '}
      <CopyableValue copyValue={trimmed} ariaLabel="Copy order number" className="align-baseline">
        {/* Copy the full id regardless of truncation; keep the ellipsis + tooltip for display. */}
        <span className="font-mono" title={isTruncated ? trimmed : undefined}>
          {display}
        </span>
      </CopyableValue>
    </span>
  )
}
